module.exports = __webpack_public_path__ + "education.svg?ad5b8eb291aeeb7ccb7e20b264fd7278";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/education.svg
// module id = 107
// module chunks = 0